<template>
  <footer class="footer" >
    <BContainer class="container-fluid text-center">
            <BRow class="justify-content-center">
                <BCol cols="auto">          
                      <button @click="scrollTop" 
                       type="button" 
                       :style="`display: ${scrollBtn ? 'block' : 'none'}`"  
                       :class="`btn-to-top ${$screen.showDesktopAds ? 'mb-1' : 'mb-5'}`" > 
                       <i class="esei icon-chevron-up"></i>
                      </button>
                </BCol>
                <BCol cols="auto">
                    <div v-html="text"></div>
                </BCol>
            </BRow>
            <BRow class="justify-content-center">
                <BCol cols="auto">
       <a href="https://www.facebook.com/pijaceCom"
   target="_blank"
   rel="noopener noreferrer"
   aria-label="Facebook stranica Pijace.com"
   title="Facebook stranica Pijace.com">
  <i class="esei icon-square-facebook-brands-solid facebook-footer rounded" aria-hidden="true"></i>
  <span class="visually-hidden">Facebook stranica Pijace.com</span>
</a>

<a href="https://www.instagram.com/pijacecom/"
   target="_blank"
   rel="noopener noreferrer"
   aria-label="Instagram profil Pijace.com"
   title="Instagram profil Pijace.com">
  <i class="esei icon-square-instagram-brands-solid facebook-instagram rounded" aria-hidden="true"></i>
  <span class="visually-hidden">Instagram profil Pijace.com</span>
</a>

<a href="https://twitter.com/PijaceCom"
   target="_blank"
   rel="noopener noreferrer"
   aria-label="X profil Pijace.com"
   title="X profil Pijace.com">
  <i class="esei icon-x-twitter-brands-solid facebook-twitter rounded" aria-hidden="true"></i>
  <span class="visually-hidden">X profil Pijace.com</span>
</a>

<a href="https://www.google.com/search?q=Pijace.com"
   target="_blank"
   rel="noopener noreferrer"
   aria-label="Google pretraga za Pijace.com"
   title="Google pretraga za Pijace.com">
  <i class="esei icon-google-brands-solid facebook-google rounded" aria-hidden="true"></i>
  <span class="visually-hidden">Google pretraga za Pijace.com</span>
</a>

<a href="https://www.youtube.com/channel/UCxEETnLxBp51J3v9i4d0d8Q/featured"
   target="_blank"
   rel="noopener noreferrer"
   aria-label="YouTube kanal Pijace.com"
   title="YouTube kanal Pijace.com">
  <i class="esei icon-youtube-brands-solid facebook-youtube rounded" aria-hidden="true"></i>
  <span class="visually-hidden">YouTube kanal Pijace.com</span>
</a>
                </BCol>
            </BRow>
            <BRow class="justify-content-center">
                <BCol cols="auto">
                    <p>Pijace.com koristi cookie-je (kolačiće) da bi obezbedio optimalno korisničko iskustvo naših posetilaca. Ako dalje nastavite korišćenje sajta prihvatate cookie-je (kolačiće) i smatramo da ste saglasni sa našom 
                     <NuxtLink to="/politika-privatnosti">
                        Politikom privatnosti
                    </NuxtLink>
                             i                        
                     <NuxtLink to="/uslovi-koriscenja">
                         Uslovima korišćenja
                     </NuxtLink>
                         U suprotnom izađite sa sajta.
                    </p>
                </BCol>
            </BRow>
        </BContainer>
  </footer>
</template>

<script setup>
import { BCol, BContainer, BRow } from 'bootstrap-vue-next';

const device = useDevice()

const scrollBtn = ref(false);

const handleScroll = () => {
  
          if (window.scrollY > 200) {
             scrollBtn.value = true
           }
           else if (window.scrollY < 200) {
             scrollBtn.value = false
           }

}

const scrollTop = () => {

  window.scrollTo(0, 0);

}


onMounted(() => window.addEventListener('scroll', handleScroll));
//onUnmounted(() => window.removeEventListener('scroll', handleScroll));

const text = ref(
  `<p>Sve cene na sajtu su postavljene od strane korisnika.<br> Pijace.com ne garantuje da su sve informacije o proizvodima potpuno tačne i bez grešaka.<br> Copyright © 2015 - ${new Date().getFullYear()} Pijace.com Sva prava su zadržana.<br></p><p>Cene na pijacama - stoka, voće, povrće, žitarice</p>`
)
 
 
</script>


